import { trim, isType } from "@utils";

const doc = window.document;

function get(key) {
  if (!key || !_has(key)) {
    return null;
  }
  let regexpStr =
    "(?:^|.*;\\s*)" +
    encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
    "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
  return JSON.parse(
    decodeURIComponent(doc.cookie.replace(new RegExp(regexpStr), "$1"))
  );
}

function all() {
  let cookies = doc.cookie.split(/; ?/g),
    data = {};
  for (let i = cookies.length - 1; i >= 0; i--) {
    if (!trim(cookies[i])) {
      continue;
    }
    let kvp = cookies[i].split("=");
    let key = decodeURIComponent(kvp[0]);
    data[key] = decodeURIComponent(kvp[1]);
  }
  return data;
}

function set(key, data, time) {
  if (!key) {
    return;
  }
  
  try {
    let expires = "Tue, 19 Jan 2038 03:14:07 GMT";
    if (time) {
      let date;
      if (isType(time, "Date")) {
        date = time;
      } else {
        date = new Date();
        date.setTime(date.getTime() + time * 60000);
      }
      expires = date.toGMTString();
    }

    data = JSON.stringify(data);
    const cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(data)}; expires=${expires}; path=/`;
    doc.cookie = cookieStr;
    
    // 验证cookie是否设置成功
    if (!_has(key)) {
      console.error('Cookie设置失败:', key);
    }
  } catch (error) {
    console.error('设置Cookie时发生错误:', error);
  }
}

function remove(key) {
  if (!key || !_has(key)) {
    return;
  }
  doc.cookie =
    encodeURIComponent(key) +
    "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function clearAll() {
  Object.keys(all()).forEach(function (key) {
    remove(key);
  });
}

function _has(key) {
  return new RegExp(
    "(?:^|;\\s*)" +
      encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
      "\\s*\\="
  ).test(doc.cookie);
}

export default {
  get,
  all,
  set,
  remove,
  clearAll,
  has: _has,
};
